import labelMajorca from "./assets/label-majorca.png";
import labelPreto from "./assets/label-preto.png";
import labelColorida from "./assets/label-colorida.png";
import labelColoridaVazio from "./assets/label-colorida-vazio.png";
import labelVazio from "./assets/label-vazio.png";
import { bucketForVisual } from "./labelTemplates";

/**
 * Recorte da etiqueta slot 0 dentro do template A4, em pontos.
 * ReportLab (origem embaixo): x 64, y 668.9, 207 x 127.
 * Em coordenadas de topo: left 64, top 46 (841.9 - 668.9 - 127).
 */
export const LABEL_BOX = { left: 64, top: 46, width: 207, height: 127 };

/** Compatibilidade: mesma caixa em coordenadas ReportLab. */
export const ARTWORK_LAYOUT = { x: 64, y: 668.9, width: 207, height: 127 };

/** Um PNG por template — extraído do próprio SEM-TEXTO usado na geração. */
const FRAME_BY_BUCKET = {
  majorca: labelMajorca,
  dourado: labelPreto,
  dourado_quad: labelMajorca,
  colorida: labelColorida,
  colorida_vazio: labelColoridaVazio,
  vazio: labelVazio,
};

export const getFrameAsset = (visual) =>
  FRAME_BY_BUCKET[bucketForVisual(visual)] || labelMajorca;
